import { v4 } from 'uuid';
import { z } from 'zod';
import { sizeSchema } from '../../Shared.js';
import { itemSchema } from './items/index.js';

const pageSchema = z.object({
  id: z.string().default(() => v4()),
  title: z.string().default(""),
  aspectRatio: z.number().default(0.6),
  naturalSize: sizeSchema.nullish().default(null),
  items: z.array(itemSchema).default([])
});

export { pageSchema };
//# sourceMappingURL=Page.js.map
